import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/portaliServiziTop';
import { selectors, DEFAULT_STATE } from '../reducers/portaliServiziTop';
import api from '../apis/portaliServiziTop';

const sagas = helper.createSagas(
    'portaliServiziTop',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        resourceLabel: 'Servizi Top Portali'
    }
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
